import SpinnerDiv from "ui/SpinnerDiv";
import HookSubFormChildDetails from "root/Base/HookFormComponents/HookSubFormChildDetails";
import {SaveButton} from "root/Modals/SaveButton";
import React, {Fragment, useEffect, useState} from "react";
import DropdownExLacChildren from "root/ReactHookForm/ui/DropdownExLacChildren";
import {useChildContext} from "root/Contexts/ChildContext";
import {childHeader} from "root/Base/HookFormComponents/childDataFormHelpers";
import {useForm} from "react-hook-form";
import {newChildModes} from "root/NewToLAC/CreateChild3";

const ReturningChildForm = ({notify}) =>
{
    const [selectedChildId, setSelectedChildId] = useState(null);

    const { getChildData, isLoading, child, isPost16 } = useChildContext() ;

    const { reset, resetField, register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                ... childHeader(child),
            }
        });

    useEffect(() =>
    {
        if ( selectedChildId !== null )
        {
            getChildData ( selectedChildId ) ;
        }
    }, [selectedChildId]);

    useEffect(() =>
    {
        if ( isLoading === false )
        {
            const d = childHeader(child) ;

            reset ( {header: d.header}, {
                shouldDirty: true
            } ) ;
        }
    }, [isLoading]);

    const onChildChange = (ddvalue) =>
    {
        setSelectedChildId(ddvalue.value);
    }

    const onSubmit = (data) =>
    {
        console.log(data);
    }

    const onClickSaveForm = (status) =>
    {
        // Set the system variable with data we want to keep. This will be ignored by the form processor
        notify(
            {
                fragment: {form: {mode: newChildModes.RETURNING, child_id: selectedChildId}},
                stage: 2
            });
    }

    const acceptRow = () => {

        const controlProps = {
            control: control,
            register: register,
            watch: watch,
            formErrors: formErrors,
            readOnly: true
        }

        return (
            isLoading ? <SpinnerDiv/> : <form className='' onSubmit={handleSubmit(onSubmit)}>

                <HookSubFormChildDetails key='childDetailForm' {...controlProps} search={false} sectionName='header' isPost16={isPost16}/>

                <div className="button-row top-margin">
                    <SaveButton disabled={false} onClick={onClickSaveForm} kay={'sb'}>Confirm Reinstate</SaveButton>
                </div>
            </form>
        )
    }

    return (
        <Fragment>
            <label className='col-form-label'>Please select a pupil to re-instate</label>
            <DropdownExLacChildren name={'child'} readOnly={false} onChange={onChildChange} initialValue={null} isSearchable={true}/>
            {selectedChildId !== null && isLoading === false && acceptRow()}
        </Fragment>
    )
}

export default ReturningChildForm ;